/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type InsightsChartType =
  | ChartType.Bar
  | ChartType.Line
  | ChartType.Column
  | ChartType.Pie
  | ChartType.Table
  | ChartType.Metric
  | ChartType.FunnelSteps
  | ChartType.FunnelTopPaths
  | ChartType.RetentionCurve;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "TimeUnit".
 */
export type TimeUnit = BaseTimeUnit | ExtendedTimeUnit | NonStandardTimeUnit | SpecialTimeUnit;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FilteredBreakdownSegments".
 */
export type FilteredBreakdownSegments = SavedLegend | SavedLegend[];
/**
 * used for specifying label or color overrides on specific segments
 */
export type LegendOverrides = {
  [k: string]: LegendOverride;
} | null;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "DataGroupId".
 */
export type DataGroupId = string | null;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "JsonValue".
 */
export type JsonValue = any;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ShowClause".
 */
export type ShowClause = FormulaShowClause | BehaviorShowClause;
export type MultiAttributionType1 = MultiAttributionType.Custom;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FiltersDeterminer".
 */
export type FiltersDeterminer = "all" | "any";
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "RetentionType".
 */
export type RetentionType = "compounded" | "birth" | "addiction";
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "RetentionUnboundedModeType".
 */
export type RetentionUnboundedModeType = "none" | "carry_back" | "carry_forward" | "consecutive_forward";
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "MATH_TYPE".
 */
export type MATH_TYPE =
  | PRIMITIVE_MATH_TYPES
  | NUMERIC_MATH_TYPES
  | XAU_MATH_TYPES
  | PER_USER_AGGREGATIONS
  | FUNNELS_MATH_TYPES
  | RETENTION_MATH_TYPES;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SortConfig".
 */
export type SortConfig = SortByColumnsConfig | SortByValueConfig;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FlatSortConfig".
 */
export type FlatSortConfig = FlatLabelSortConfig | FlatValueSortConfig;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FlatOrColumnSortConfig".
 */
export type FlatOrColumnSortConfig = FlatSortConfig | SortConfig;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ViewNLimit".
 */
export type ViewNLimit = number | null;

export interface InsightsBookmarkParams {
  columnWidths?: ColumnWidths | null;
  displayOptions: DisplayOptions;
  forecastComparison?: ForecastComparison | null;
  legend?: InsightsLegend | null;
  liftComparison?: LiftComparison | null;
  name?: string | null;
  sections: Sections;
  sorting?: InsightsBookmarkSortConfig | null;
  timeComparison?: any;
  versions?: string[] | null;
  executedMigrations?: ExecutedMigration[] | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ColumnWidths".
 */
export interface ColumnWidths {
  bar?: {
    [k: string]: number;
  } | null;
  dataTable?: DataTableColumnWidthOverrides | null;
  [k: string]: any;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "DataTableColumnWidthOverrides".
 */
export interface DataTableColumnWidthOverrides {
  report?: {
    [k: string]: number;
  } | null;
  dashboard?: {
    [k: string]: number;
  } | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "DisplayOptions".
 */
export interface DisplayOptions {
  chartType: InsightsChartType;
  plotStyle?: ChartPlotStyle | null;
  analysis?: AnalysisType | null;
  value?: ValueRepresentationType | null;
  rollingWindowSize?: number | null;
  timeUnit?: TimeUnit | null;
  primaryYAxisOptions?: any;
  secondaryYAxisOptions?: any;
  theme?: any;
  xAxisOptions?: any;
  annotationOptions?: AnnotationOptions | null;
  commentOptions?: CommentOptions | null;
  queryTimeSampling?: boolean | null;
  tableSummaryAggregation?: TableSummaryAggregation | null;
  statSigControl?: SegmentId[] | null;
  funnelStepsSelectedTableColumns?: FunnelStepsSelectedTableColumns | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "AnnotationOptions".
 */
export interface AnnotationOptions {
  tagFilterIds?: number[] | null;
  showUntagged?: boolean | null;
  sortOrder?: SortOrderType | null;
  hideAnnotations?: boolean | null;
  creatorFilterIds?: number[] | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "CommentOptions".
 */
export interface CommentOptions {
  commentsDisabled?: boolean | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SegmentId".
 */
export interface SegmentId {
  /**
   * raw string value of the segment
   */
  prop: string;
  /**
   * user-friendly renaming of prop, suitable for printing
   */
  propName?: string | null;
  /**
   * Query parameters not encapsulated by the prop which are necessary to recreate
   * this segment.
   *
   * ex: bucketSize and index for a bucketed numeric segment
   */
  cohortDesc?: {
    [k: string]: any;
  };
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FunnelStepsSelectedTableColumns".
 */
export interface FunnelStepsSelectedTableColumns {
  "conv-first-step"?: boolean;
  "conv-prev-step"?: boolean;
  count?: boolean;
  "stat-sig"?: boolean;
  "time-first-step"?: boolean;
  "time-prev-step"?: boolean;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ForecastComparison".
 */
export interface ForecastComparison {
  confidence: number;
  trainingMode: string;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "InsightsLegend".
 */
export interface InsightsLegend {
  /**
   * used for flat data, entire selected segments
   */
  individualSelectedSegments?: SavedLegend | null;
  /**
   * used for nested (bar chart) data, filtered segments at each level
   */
  filteredBreakdownSegments?: FilteredBreakdownSegments | null;
  overrides?: LegendOverrides;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SavedLegend".
 */
export interface SavedLegend {
  selected?: SavedLegendItem[] | null;
  expanded?: SavedLegendItem[] | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SavedLegendItem".
 */
export interface SavedLegendItem {
  key?: string | null;
  /**
   * might still exist on old bookmarks, but it's not used anymore
   */
  color?: number | null;
  partial?: boolean | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "LegendOverride".
 */
export interface LegendOverride {
  color: string;
  label?: string | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "LiftComparison".
 */
export interface LiftComparison {
  cohort?: any;
  comparisonProperty?: any;
  groupValue?: string | null;
  type: LiftType;
  controlVariant?: string | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "Sections".
 */
export interface Sections {
  cohorts?: GroupByCohort[] | null;
  filter?: JsonValue[] | null;
  formula?: FormulaClause[] | null;
  globalDataGroupId?: string | null;
  group?: GroupClause[] | null;
  group_by?: GroupClause[] | null;
  metricLevelDataGroups?: boolean | null;
  show: ShowClause[];
  time: JsonValue[];
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "GroupByCohort".
 */
export interface GroupByCohort {
  count?: number | null;
  created_by?: any;
  dataset?: string | null;
  data_group_id?: DataGroupId | null;
  description?: string | null;
  groups?: JsonValue[] | null;
  is_locked?: boolean | null;
  is_visible?: boolean | null;
  id?: number | string | null;
  isInherited?: boolean | null;
  last_edited?: string | null;
  name?: string | null;
  negated?: boolean | null;
  raw_cohort?: any;
  resourceType?: InsightsResourceType | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FormulaClause".
 */
export interface FormulaClause {
  value: string;
  label?: string | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "GroupClause".
 */
export interface GroupClause {
  behavior?: any;
  cohorts?: GroupByCohort[] | null;
  customBucket?: Bucket | null;
  customGroups?: any;
  customProperty?: any;
  customPropertyId?: number | string | null;
  dataGroupId?: string | null;
  dataset?: string | null;
  datasetId?: string | null;
  defaultType?: PropertyType | null;
  editing?: boolean | null;
  endStepNumber?: number | null;
  experiments?: any;
  filterDateUnit?: TimeUnit | null;
  filterJoinType?: PropertyType | null;
  filterOperator?: string | null;
  filterType?: PropertyType | null;
  filterValue?: any;
  id?: string | null;
  isHidden?: boolean | null;
  isInherited?: boolean | null;
  joinPropertyType?: PropertyType | null;
  listItemGroup?: any;
  listQuantifier?: ListQuantifier | null;
  profileHistoryOptions?: any;
  profileType?: string | null;
  projectId?: number | null;
  propertyDefaultType?: PropertyType | null;
  propertyFilter?: any;
  propertyName?: string | string[] | null;
  propertyObjectKey?: string | string[] | null;
  propertyType?: PropertyType | null;
  resourceType?: InsightsResourceType | null;
  scdEvent?: string | null;
  scdOptions?: any;
  search?: string | null;
  startStepNumber?: number | null;
  tempDataGroupId?: string | null;
  type?: InsightsResourceType | null;
  typeCast?: PropertyType | null;
  unit?: any;
  value?: any;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "Bucket".
 */
export interface Bucket {
  bucketSize?: number | null;
  disabled?: boolean | null;
  groups?: number[] | null;
  max?: number | null;
  min?: number | null;
  offset?: number | null;
  unit?: string | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FormulaShowClause".
 */
export interface FormulaShowClause {
  _idx?: string;
  type?: TopLevelMetricType.Formula;
  formula?: any;
  measurement?: FormulaMeasurement | null;
  statsig?: Statsig | null;
  display?: MetricDisplay | null;
  isHidden?: boolean | null;
  isExpanded?: boolean | null;
  userNamed?: boolean | null;
  comparisons?: JsonValue[] | null;
  id?: number | null;
  definition?: string | null;
  name?: string | null;
  referencedMetrics?: BehaviorShowClause[] | null;
  hasUnsavedChanges?: boolean | null;
  overrides?: {
    [k: string]: any;
  } | null;
  goals?: Goal[] | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FormulaMeasurement".
 */
export interface FormulaMeasurement {
  cumulative?: boolean | null;
  rolling?: RollingMeasurement | null;
  multiAttribution?: PredefinedMultiAttribution | CustomMultiAttribution | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "RollingMeasurement".
 */
export interface RollingMeasurement {
  rollingWindowSize?: number | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "PredefinedMultiAttribution".
 */
export interface PredefinedMultiAttribution {
  type: MultiAttributionType;
  name?: string | null;
  weights?: MultiAttributionWeights | null;
  step_index?: number | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "MultiAttributionWeights".
 */
export interface MultiAttributionWeights {
  first: number;
  middle: number;
  last: number;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "CustomMultiAttribution".
 */
export interface CustomMultiAttribution {
  type: MultiAttributionType1;
  name: string;
  weights: MultiAttributionWeights;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "Statsig".
 */
export interface Statsig {
  confidence?: number | null;
  control_key: string;
  sequential_testing_adjustment?: any;
  pre_exposure_date_range?: string[] | null;
  winsorization?: Winsorization | null;
  math?: string | null;
  exposures?: {
    [k: string]:
      | number
      | {
          [k: string]: number;
        };
  } | null;
  version?: string | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "Winsorization".
 */
export interface Winsorization {
  enabled?: boolean | null;
  lower_percentile?: number | null;
  upper_percentile?: number | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "MetricDisplay".
 */
export interface MetricDisplay {
  abbrev?: boolean | null;
  axis?: AxisAssignment | null;
  direction?: ("up" | "down") | null;
  hideTrendline?: boolean | null;
  precision?: (0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8) | null;
  prefix?: string | null;
  suffix?: string | null;
  trendline?: boolean | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "BehaviorShowClause".
 */
export interface BehaviorShowClause {
  _idx?: string;
  type?: TopLevelMetricType.Metric;
  id?: number | null;
  userNamed?: boolean | null;
  name?: string | null;
  behavior?: Behavior | null;
  measurement?: BehaviorMeasurement | null;
  statsig?: Statsig | null;
  srm?: SRM | null;
  comparisons?: JsonValue[] | null;
  display?: MetricDisplay | null;
  isHidden?: boolean | null;
  isExpanded?: boolean | null;
  labelPrefix?: string | null;
  formulaLabel?: string | null;
  showClauseIndex?: number | null;
  hasUnsavedChanges?: boolean | null;
  goals?: Goal[] | null;
  overrides?: {
    [k: string]: any;
  } | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "Behavior".
 */
export interface Behavior {
  type?: MetricType | null;
  id?: number | null;
  name?: string | null;
  renamed?: string | null;
  dataGroupId?: string | null;
  filters?: JsonValue[] | null;
  filtersDeterminer?: FiltersDeterminer | null;
  resourceType?: InsightsResourceType | null;
  behaviors?: SubBehavior[] | null;
  raw_cohort?: any;
  customBucket?: Bucket | null;
  conversionWindowDuration?: number | null;
  conversionWindowUnit?: ConversionWindowUnit | null;
  funnelReentryMode?: FunnelReentryModeType | null;
  funnelOrder?: FunnelOrder | null;
  exclusions?: ExclusionFunnelStep[] | null;
  aggregateBy?: JsonValue[] | null;
  retentionType?: RetentionType | null;
  retentionAlignmentType?: RetentionAlignmentType | null;
  retentionUnit?: TimeUnit | null;
  retentionUnbounded?: boolean | null;
  retentionUnboundedMode?: RetentionUnboundedModeType | null;
  retentionCustomBucketSizes?: number[] | null;
  segmentationEvent?: string | null;
  unsavedId?: string | null;
  search?: string | null;
  profileType?: string | null;
  dataset?: string | null;
  datasetId?: string | null;
  projectId?: number | null;
  display?: MetricDisplay | null;
  disableCohortize?: boolean | null;
  customEventSet?: boolean | null;
  hasUnsavedChanges?: boolean | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SubBehavior".
 */
export interface SubBehavior {
  _idx?: string | null;
  type?: MetricType.Event | MetricType.CustomEvent | MetricType.Funnel;
  id?: number | null;
  name?: string | null;
  renamed?: string | null;
  filters?: JsonValue[] | null;
  filtersDeterminer?: FiltersDeterminer | null;
  funnelOrder?: FunnelOrder | null;
  behaviors?: SubBehavior[] | null;
  display?: MetricDisplay | null;
  customEventSet?: boolean | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ExclusionFunnelStep".
 */
export interface ExclusionFunnelStep {
  bool_op?: FiltersOperator | null;
  property_filter_params_list?: JsonValue[] | null;
  event?: string | null;
  event_id?: number | null;
  custom_event?: number | null;
  custom_event_name?: string | null;
  step_label?: string | null;
  session_event?: START_END_TYPE | null;
  forward?: number | null;
  reverse?: number | null;
  steps: StepRange;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "StepRange".
 */
export interface StepRange {
  from?: number | null;
  to?: number | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "BehaviorMeasurement".
 */
export interface BehaviorMeasurement {
  dataGroupId?: DataGroupId | null;
  math?: MATH_TYPE | null;
  property?: any;
  cumulative?: boolean | null;
  perUserAggregation?: PER_USER_AGGREGATIONS | null;
  rolling?: RollingMeasurement | null;
  segmentMethod?: COUNT_USERS_ONCE_TYPE | null;
  multiAttribution?: PredefinedMultiAttribution | CustomMultiAttribution | null;
  stepIndex?: number | null;
  actionMode?: string | null;
  actionStep?: number | null;
  retentionBucketIndex?: number | null;
  retentionCumulative?: boolean | null;
  retentionSegmentationEvent?: any;
  percentile?: number | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SRM".
 */
export interface SRM {
  expectedRatios: {
    [k: string]: number;
  };
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "Goal".
 */
export interface Goal {
  id: string;
  label: string;
  checkpoints: [any, any][];
  target_type?: "absolute" | "relative";
  target_input?: number | null;
  unit?: any;
  direction?: any;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "InsightsBookmarkSortConfig".
 */
export interface InsightsBookmarkSortConfig {
  bar?: SortConfig | null;
  table?: SortConfig | OldTableSortByValue | null;
  /**
   * In the bookmark, line chart can either have the old FlatSortConfig or the new SortConfig format
   */
  line?: FlatOrColumnSortConfig | null;
  "insights-metric"?: SortConfig | null;
  pie?: SortConfig | null;
  /**
   * Retention specific
   */
  "retention-curve"?: SortConfig | null;
  "funnel-steps"?: SortConfig | null;
}
/**
 * sort by segment columns (segment-grouped sort)
 *
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SortByColumnsConfig".
 */
export interface SortByColumnsConfig {
  sortBy: SortBy.Column;
  /**
   * value field to specify which value to sort secondarily on
   */
  valueField?: string | null;
  colSortAttrs: FlatSortConfig[];
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FlatLabelSortConfig".
 */
export interface FlatLabelSortConfig {
  sortBy: SortBy.Label;
  sortOrder: SortOrder;
  valueField?: string | null;
  viewNLimit?: number | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FlatValueSortConfig".
 */
export interface FlatValueSortConfig {
  sortBy: SortBy.Value;
  sortOrder: SortOrder;
  /**
   * valueField required when sorting by value (sortBy.Value) and there is > 1 valueField. Used for data tables.
   */
  valueField?: string | null;
  viewNLimit?: number | null;
}
/**
 * sort by a single value column (flat sort). Still persists colSortAttrs so that if we switch back to sorting by
 * columns, we preserve the prior sorts on the columns
 *
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SortByValueConfig".
 */
export interface SortByValueConfig {
  sortBy: SortBy.Value;
  sortOrder?: SortOrder | null;
  /**
   * valueField required when sorting by value (sortBy.Value) and there is > 1 valueField. Used for data tables.
   */
  valueField?: string | null;
  colSortAttrs: FlatSortConfig[];
  viewNLimit?: number | null;
}
/**
 * Same as SortByValueConfig except:
 * 1) sortColumn instead of valueField
 * 2) colSortAttrs can only be FlatLabelSortConfig, not FlatValueSortConfig
 *
 * Must convert this for use with data-table
 *
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "OldTableSortByValue".
 */
export interface OldTableSortByValue {
  sortBy: SortBy.Value;
  sortOrder: SortOrder;
  sortColumn: SortColumn;
  colSortAttrs: FlatSortConfig[];
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ExecutedMigration".
 */
export interface ExecutedMigration {
  name: string;
  succeeded: boolean;
  version: string;
}

/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ChartPlotStyle".
 */
export enum ChartPlotStyle {
  Standard = "standard",
  Stacked = "stacked"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "AnalysisType".
 */
export enum AnalysisType {
  Linear = "linear",
  Logarithmic = "logarithmic",
  Rolling = "rolling",
  Cumulative = "cumulative"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ValueRepresentationType".
 */
export enum ValueRepresentationType {
  Absolute = "absolute",
  Relative = "relative"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "BaseTimeUnit".
 */
export enum BaseTimeUnit {
  Hour = "hour",
  Day = "day",
  Week = "week",
  Month = "month"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ExtendedTimeUnit".
 */
export enum ExtendedTimeUnit {
  Second = "second",
  Minute = "minute",
  Quarter = "quarter",
  Year = "year"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "NonStandardTimeUnit".
 */
export enum NonStandardTimeUnit {
  Session = "session"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SpecialTimeUnit".
 */
export enum SpecialTimeUnit {
  HourOfDay = "hour_of_day",
  DayOfWeek = "day_of_week"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SortOrderType".
 */
export enum SortOrderType {
  Ascending = "asc",
  Descending = "desc"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "TableSummaryAggregation".
 */
export enum TableSummaryAggregation {
  Average = "average",
  Sum = "sum",
  Min = "min",
  Max = "max",
  Median = "median"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "LiftType".
 */
export enum LiftType {
  Overall = "percentOverall",
  Segment = "segment",
  Time = "timeComparison",
  Experiment = "experiment"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "InsightsResourceType".
 */
export enum InsightsResourceType {
  All = "all",
  Cohort = "cohort",
  Cohorts = "cohorts",
  Event = "event",
  Events = "events",
  Formulas = "formulas",
  Other = "other",
  People = "people",
  User = "user"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "PropertyType".
 */
export enum PropertyType {
  Boolean = "boolean",
  Datetime = "datetime",
  List = "list",
  Number = "number",
  String = "string",
  Dimension = "dimension",
  Object = "object",
  NonProperty = "other",
  Unknown = "unknown"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ListQuantifier".
 */
export enum ListQuantifier {
  Any = "any",
  All = "all",
  Flatten = "flatten"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "MultiAttributionType".
 */
export enum MultiAttributionType {
  FirstTouch = "first_touch",
  LastTouch = "last_touch",
  Linear = "linear",
  Participation = "participation",
  TimeDecay = "time_decay",
  UShaped = "u_shaped",
  JShaped = "j_shaped",
  InverseJShaped = "inverse_j_shaped",
  Custom = "custom",
  SessionReplayLast = "session_replay_last"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "AxisAssignment".
 */
export enum AxisAssignment {
  Primary = "primary",
  Secondary = "secondary"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "MetricType".
 */
export enum MetricType {
  Cohort = "cohort",
  CustomEvent = "custom-event",
  Event = "event",
  Formula = "formula",
  Funnel = "funnel",
  People = "people",
  Retention = "retention",
  RetentionFrequency = "retention-frequency",
  SavedMetric = "saved-metric",
  Simple = "simple",
  Verified = "verified"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FunnelOrder".
 */
export enum FunnelOrder {
  Loose = "loose",
  Any = "any"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ConversionWindowUnit".
 */
export enum ConversionWindowUnit {
  Second = "second",
  Minute = "minute",
  Hour = "hour",
  Day = "day",
  Week = "week",
  Month = "month",
  Session = "session"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FunnelReentryModeType".
 */
export enum FunnelReentryModeType {
  Default = "default",
  Basic = "basic",
  Aggressive = "aggressive",
  Optimized = "optimized"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FiltersOperator".
 */
export enum FiltersOperator {
  And = "and",
  Or = "or",
  OrAll = "or_all",
  AndAny = "and_any",
  Then = "then"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "START_END_TYPE".
 */
export enum START_END_TYPE {
  start = "start",
  end = "end"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "RetentionAlignmentType".
 */
export enum RetentionAlignmentType {
  Birth = "birth",
  IntervalStart = "interval_start"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "PRIMITIVE_MATH_TYPES".
 */
export enum PRIMITIVE_MATH_TYPES {
  TOTAL = "total",
  UNIQUE = "unique",
  SESSIONS = "sessions",
  AVERAGE = "average",
  MEDIAN = "median",
  P25 = "p25",
  P75 = "p75",
  P90 = "p90",
  P99 = "p99",
  CUSTOM_PERCENTILE = "custom_percentile",
  MIN = "min",
  MAX = "max",
  CUMULATIVE_UNIQUE = "cumulative_unique",
  HISTOGRAM = "histogram",
  UNIQUE_VALUES = "unique_values",
  MOST_FREQUENT = "most_frequent",
  FIRST_VALUE = "first_value",
  MULTI_ATTRIBUTION = "multi_attribution",
  NUMERIC_SUMMARY = "numeric_summary"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "NUMERIC_MATH_TYPES".
 */
export enum NUMERIC_MATH_TYPES {
  P25 = "p25",
  P75 = "p75",
  P90 = "p90",
  P99 = "p99"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "XAU_MATH_TYPES".
 */
export enum XAU_MATH_TYPES {
  DAU = "dau",
  WAU = "wau",
  MAU = "mau"
}
/**
 * only a subset of operations are valid for per user aggregations, keep this enum separate
 *
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "PER_USER_AGGREGATIONS".
 */
export enum PER_USER_AGGREGATIONS {
  TOTAL = "total",
  AVERAGE = "average",
  MIN = "min",
  MAX = "max",
  UNIQUE_VALUES = "unique_values",
  SESSION_REPLAY_ID_VALUE = "session_replay_id_value"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FUNNELS_MATH_TYPES".
 */
export enum FUNNELS_MATH_TYPES {
  GENERAL = "general",
  UNIQUE = "unique",
  SESSION = "session",
  CONVERSION_RATE = "conversion_rate",
  CONVERSION_RATE_UNIQUE = "conversion_rate_unique",
  CONVERSION_RATE_TOTAL = "conversion_rate_total",
  CONVERSION_RATE_SESSION = "conversion_rate_session",
  PROPERTY_SUM = "total"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "RETENTION_MATH_TYPES".
 */
export enum RETENTION_MATH_TYPES {
  UNIQUE = "unique",
  RETENTION_RATE = "retention_rate",
  PROPERTY_SUM = "total",
  PROPERTY_AVERAGE = "average"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "COUNT_USERS_ONCE_TYPE".
 */
export enum COUNT_USERS_ONCE_TYPE {
  MULTIPLE = "all",
  FIRST = "first",
  LAST = "last"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SortOrder".
 */
export enum SortOrder {
  Ascending = "asc",
  Descending = "desc"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SortColumn".
 */
export enum SortColumn {
  Linear = "Linear",
  Sum = "sum",
  Value = "value"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ChartType".
 */
export enum ChartType {
  Bar = "bar",
  Line = "line",
  Pie = "pie",
  StackedBar = "bar-stacked",
  StackedLine = "stacked-line",
  Table = "table",
  Metric = "insights-metric",
  Column = "column",
  StackedColumn = "stacked-column",
  LegacyMetric = "metric",
  Sankey = "sankey",
  Flows = "flows",
  FlowsTopPaths = "paths",
  FunnelTopPaths = "funnel-top-paths",
  FunnelSteps = "funnel-steps",
  FunnelStepsMetric = "funnel-steps-metric",
  FunnelTrend = "funnel-trend",
  FunnelFrequencyLine = "funnel-frequency-line",
  FunnelFrequencyBar = "funnel-frequency-bar",
  FunnelTTCLine = "funnel-ttc-line",
  FunnelTTCBar = "funnel-ttc-bar",
  FunnelMedianTTC = "funnel-median-ttc",
  RetentionLine = "line-retention",
  RetentionTrend = "retention-trend",
  RetentionTrendMetric = "retention-trend-metric",
  RetentionTable = "retention-table",
  RetentionCurve = "retention-curve",
  Frequency = "frequency",
  ImpactAdoption = "impact-adoption",
  ImpactTrends = "impact-trends",
  ImpactPropensity = "impact-propensity"
}
/**
 * This exists at the top of a metric / show clause.
 *
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "TopLevelMetricType".
 */
export enum TopLevelMetricType {
  Metric = "metric",
  Formula = "formula",
  MetricEntry = "metric-entry",
  NewMetricEntry = "new-metric-entry",
  NewFormulaEntry = "new-formula-entry"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SortBy".
 */
export enum SortBy {
  Value = "value",
  Label = "label",
  Column = "column",
  LiftComparisonValue = "liftComparisonValue"
}
